import styled, { css } from 'styled-components'

import { Box } from '../Box'
import { Button } from '../Button'
import { Space } from '../Space'
import { Title } from '../Text'
import { themeColor, themeSpace } from '../theme'

export interface BannerProps {
  title: string
  bannerCmsHtmlContent: string
  link?: {
    text: string
    url: string
    target: string
  }
}

const Container = styled(Box)`
  transition: transform 0.15s ease-in-out;
  filter: blur(0);

  &:hover {
    transform: scale(1.03);
  }
`

const Content = styled(Space)<{ withLink?: boolean }>`
  flex-direction: column;
  padding: ${themeSpace(3)};
  width: 100%;
  border: 1px solid ${themeColor('borderPrimary')};

  ${({ withLink }) =>
    withLink
      ? css`
          border-bottom: none;
        `
      : ''}
  border-radius: ${({ withLink }) => (withLink ? '4px 4px 0 0' : '4px')};
  background: ${themeColor('white')};
`

const ActionButton = styled(Button)`
  width: 100%;
  height: 60px;
  justify-content: center;
  border-radius: 0 0 4px 4px;
`

const Buttons = styled.div`
  display: flex;

  a {
    display: flex;
    flex: 1 1 auto;
  }
`

export const Banner = ({ title, bannerCmsHtmlContent, link }: BannerProps) => {
  return (
    <Container>
      <Content space={2} direction="vertical" withLink={!!link}>
        {link && (
          <a href={link.url} target={link.target || undefined}>
            <Title level="medium">{title}</Title>
          </a>
        )}
        {!link && <Title level="medium">{title}</Title>}
        <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: bannerCmsHtmlContent }} />
      </Content>
      {link && (
        <Buttons>
          <a href={link.url} target={link.target || undefined}>
            <ActionButton size="middle" variant="primary">
              {link.text}
            </ActionButton>
          </a>
        </Buttons>
      )}
    </Container>
  )
}
